import { useEffect } from "react";
import { createPortal } from "react-dom";

/**
 * Renders modal overlays on document.body so they sit above the shell,
 * sidebar, and theme backdrops (fixes invisible-until-click popups).
 */
export default function ModalScrim({ children, testId, onBackdropClick }) {
  useEffect(() => {
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = prev; };
  }, []);

  useEffect(() => {
    if (!onBackdropClick) return undefined;
    const onKey = (e) => {
      if (e.key === "Escape") onBackdropClick();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onBackdropClick]);

  return createPortal(
    <div
      className="modal-scrim"
      data-testid={testId}
      role="presentation"
      onClick={onBackdropClick ? (e) => { if (e.target === e.currentTarget) onBackdropClick(); } : undefined}
    >
      {children}
    </div>,
    document.body,
  );
}
